import React from 'react';
import AppShell from '../../components/app-shell/app-shell';  
import PublicShell from '../../components/app-shell/public-shell';
import PublicMarkdown from '../../components/markdown/public-markdown';
import markdown from './policies.md';

export default function() {
  return (
    <AppShell seoTitle="Policies">
      <PublicShell>
        <PublicMarkdown markdown={markdown} />
      </PublicShell>
    </AppShell>
  );
}
